import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import FeaturedProjects from '../components/FeaturedProjects';
import SpeakingEngagements from '../components/SpeakingEngagements';
import BuiltBy from '../components/BuiltBy';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Experience />
        <FeaturedProjects />
        <SpeakingEngagements />
        <BuiltBy />
      </main>
    </div>
  );
};

export default HomePage;
